import { createSelector } from 'reselect';

import { TState } from '~/src/store';

export const selectOffer = createSelector(
    (state: TState) => state.specOffers,
    ({ offers, selectedOfferId }) => offers.find(offer => offer.requestId === selectedOfferId),
);
